import React, { createContext, useState, useContext, Dispatch, SetStateAction } from 'react';
import { Paniers } from '../models/Paniers';

export interface GlobalStateInterface {
    baskets: Paniers[];
}

const GlobalStateContext = createContext({
    state: {} as GlobalStateInterface,
    setState: {} as Dispatch<SetStateAction<GlobalStateInterface>>
});

const GlobalStateProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
    const [state, setState] = useState<GlobalStateInterface>({
        baskets: []
    });

    return (
        <GlobalStateContext.Provider value={{ state, setState }}>
            {children}
        </GlobalStateContext.Provider>
    );
};

const useGlobalState = (): typeof context => {
    const context = useContext(GlobalStateContext);
    if (context) {
        return context;
    }
    return {} as typeof context;
};

export { GlobalStateProvider, useGlobalState };
